export const SETLOGIN = "SETLOGIN";
export const GETLOGIN = "GETLOGIN";